import { render, staticRenderFns } from "./organizeCard.vue?vue&type=template&id=23074721&scoped=true&"
import script from "./organizeCard.vue?vue&type=script&lang=js&"
export * from "./organizeCard.vue?vue&type=script&lang=js&"
import style0 from "./organizeCard.vue?vue&type=style&index=0&id=23074721&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23074721",
  null
  
)

export default component.exports